import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
	selector: 'spaq-debug-component',
	template: `<div>
		<span>Debug Component</span>
		<!-- <router-outlet></router-outlet> -->
	</div>`
})
export class DebugComponent {}

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild([
			{
				path: 'contract/details',
				component: DebugComponent
			}
		])
	]
})
export class DebugRoutingModule {}

@NgModule({
	imports: [RouterModule, DebugRoutingModule],
	declarations: [DebugComponent]
})
export class DebugModule {}
